
$('.multi-product-submit').click(function(e) {

    var products = $('.bt-product-bundle-items');
    var check_variants = [];

    for(let product of products){
    let variants = product.nextElementSibling.innerHTML;
        variants = JSON.parse(variants);
        $.map( variants, function( value, index ) {      
          check_variants.push({id:value.id,quantity:1});
         });
    }
    let formData = {
     'items': check_variants
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    })
    .then((json) => {
      var cart =$('#cart-drawer-popup');
      fetch(window.Shopify.routes.root + "?sections=cart-drawer")
      .then(res => res.json())
      .then((response) => {
        var success =  $($.parseHTML(response['cart-drawer'])).find("#cart-drawer-popup");
        cart.html(success[0].innerHTML) ;
        if(cart.hasClass('is-empty')){
        cart.toggleClass('is-empty');  
        }
        fetch(window.Shopify.routes.root + "?sections=cart-icon-bubble")
        .then(res => res.json())
        .then((response)=>{
            $('.cart-icon-bubble').html(response['cart-icon-bubble']);
        })
      })
    })
    .catch((error) => {
      console.error('Error:', error);
    });
});